'use strict';

import '../../.tmp/compiled-soy/atlassian-deps';
import '../../.tmp/compiled-soy/soyutils';
import '../../.tmp/compiled-soy/aui';
import '../../.tmp/compiled-soy/avatar';
import '../../.tmp/compiled-soy/badges';
import '../../.tmp/compiled-soy/buttons';
import '../../.tmp/compiled-soy/dialog2';
import '../../.tmp/compiled-soy/dropdown';
import '../../.tmp/compiled-soy/dropdown2';
import '../../.tmp/compiled-soy/expander';
import '../../.tmp/compiled-soy/form';
import '../../.tmp/compiled-soy/group';
import '../../.tmp/compiled-soy/icons';
import '../../.tmp/compiled-soy/inline-dialog2';
import '../../.tmp/compiled-soy/labels';
import '../../.tmp/compiled-soy/lozenges';
import '../../.tmp/compiled-soy/message';
import '../../.tmp/compiled-soy/navigation';
import '../../.tmp/compiled-soy/page';
import '../../.tmp/compiled-soy/panel';
import '../../.tmp/compiled-soy/progress-tracker';
import '../../.tmp/compiled-soy/sidebar';
import '../../.tmp/compiled-soy/table';
import '../../.tmp/compiled-soy/tabs';
import '../../.tmp/compiled-soy/toolbar';
import '../../.tmp/compiled-soy/toolbar2';
import '../../.tmp/compiled-soy/trigger';

export default window.aui;
